import { useEffect, useState } from "react";
import { Button } from "src/@/components/ui/button";
import { Input } from "src/@/components/ui/input";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "src/@/components/ui/select";
import { Card, CardHeader, CardContent } from "src/@/components/ui/card";
import { LabelFromAction } from "src/components/@dashboard/automacoes";

const ChatKeywordFilter = ({ 
  actionPhase,
  actionState,
  changeActionState
 }) => {
  const [filterType, setFilterType] = useState("contains"); // "equal" or "contains"
  const [keywords, setKeywords] = useState("");
  const [keywordList, setKeywordList] = useState([]);

  const handleAddKeyword = () => {
    if (keywords.trim()) {
      let event = {
        name: "chatKeywords",
        value: [...actionState?.chatKeywords, keywords.trim()]
      }
      changeActionState(event);
      setKeywordList([...keywordList, keywords.trim()]);
      setKeywords("");
    }
  };

  const handleRemoveKeyword = (keywordToRemove) => {
    let event = {
      name: "chatKeywords",
      value: actionState?.chatKeywords.filter((keyword) => keyword !== keywordToRemove)
    }
    changeActionState(event);
  };

  return (
    <Card className="w-full">
      <CardHeader>
        <LabelFromAction>
          {actionPhase.name}
        </LabelFromAction>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {/* Input for Keywords */}
          <div>
            <label className="block text-sm font-medium">Adicionar Palavras-chave</label>
            <div className="flex items-center space-x-2">
              <Input
                placeholder="Digite a palavra-chave"
                value={keywords}
                onChange={(e) => setKeywords(e.target.value)}
                className="w-full"
              />
              <Button className="bg-slate-500" onClick={handleAddKeyword}>Adicionar</Button>
            </div>
          </div>

          {/* List of Added Keywords */}
          <div>
            <h4 className="text-xs font-medium">Palavras-chave adicionadas:</h4>
            <ul className="list-disc space-y-1">
              {actionState?.chatKeywords.map((keyword, index) => (
                <li key={index} className="flex items-center justify-between">
                  <div className="px-2 bg-slate-100 border-slate-200 border rounded text-sm">{keyword}</div>

                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => handleRemoveKeyword(keyword.toString())}
                    className="text-red-500"
                  >
                    Remover
                  </Button>
                </li>
              ))}
            </ul>
          </div>

        </div>
      </CardContent>
    </Card>
  );
};

export default ChatKeywordFilter;
